import axios from '@/axios';

export async function getKinships() {
    try {
        const { data } = await axios.get("/kinship");
        return data.data ? data.data : data;
    } catch (error) {
        return { error };
    }
}

export async function saveKinship(id, data) {
    const method = id ? 'PUT' : 'POST';
    const url = id ? `/kinship/${id}` : '/kinship';
    return await axios({ method, url, data: data });
}
